import * as React from "react";
import { StyleSheet, Text, TouchableOpacity } from "react-native";

export type TabProps = {
  title: string;
  isActive: boolean;
  onPress: () => void;
};

function Tab({ title, isActive, onPress }: TabProps): React.JSX.Element {
  return (
    <TouchableOpacity style={styles.tab} onPress={onPress}>
      <Text style={[styles.tabText, isActive && styles.activeTabText]}>
        {title}
      </Text>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  activeTabText: {
    color: "#000",
    fontWeight: "bold",
  },
  tab: {
    marginHorizontal: 10,
  },
  tabText: {
    color: "#888",
    fontSize: 22,
  },
});

export default Tab;
